
const state = {
    currentTime: 0,  //初始化
    player: '',
  };
  
  const getters = {
    assiCurrentTime(state){ 
      return state.currentTime;
    },
    assiPlayer(state){ 
      return state.player;
    }
  };
  const mutations = {
    setCurrentTime(state,items){ 
      state.currentTime = items;
    },
    setPlayer(state,items){ 
      state.player = items;
    }
  };
  const actions = {
    changeCurrentTime(context,item){ 
      context.commit('setCurrentTime',item);
    },
    changePlayer(context,item){ 
      context.commit('setPlayer',item);
    }
  };
  export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }


// WEBPACK FOOTER //
// ./src/store/modules/video.js